export function getPercentage(value, totalValue) {
  if (!value || !totalValue) {
    return 0
  }
  return ((parseFloat(value) / parseFloat(totalValue)) * 100).toFixed(1)
}
